module.exports = __webpack_public_path__ + "static/img/HList6.e55deaaf.png";